export default __webpack_public_path__ + "static/sucha-skora-3c6318f82063883faab11502b317539f.png";